<input type="text" [value]="getValue()" (change)="onValueChanged($event.target.value)" autocomplete="none" [placeholder]="'components.input.search_placeholder' | translate"/>
<div class="search-icon-container">
    <span class="search-small-icon"></span>
</div>